module.exports = __webpack_public_path__ + "img/Madera-Caucho.7ed8ad08.jpg";